/**
 *  02/09/2019 v 1.0 - JuanMa
 *  V.1.1 11/09/2019 Añadidos stringDecimalComasToNumber, stringPorcentajeToNumber, stringMonedaToNumber, stringFechaHora
 *  v.1.2 03/08/2020 Modificada la función stringDecimalComasToNumber para cuando se pasa un numero y no existe la funcion replace.
 *  v.1.3 05/11/2020 Añadida función truncarCadenaConEllip
 **/

import {getDateTimeFromFormattedString} from "./DateUtils"

export const aparicionesSubcadena= (cadena, subcadena) => {
    return cadena.split(subcadena).length-1;
}

export const stringWithZerosIzq= (cadena, tamagno) => {
    return stringWithStringIzq(cadena, "0", tamagno);
}

export const stringWithStringIzq= (cadena, cadenaRelleno, tamagno) => {
    let newCadena= cadena;
    while (newCadena.length < tamagno)
        newCadena= cadenaRelleno + newCadena;
    return newCadena;
}


export const stringDecimalComasToNumber= (cadena) => {
    if (cadena) {
        //Si no existe la función es pq es un numero directamente.
        if (cadena.replace)
            return Number(cadena.replace(",", "."));
        else {
            return Number(cadena);
        }
    }
    else
        return 0;
}

export const stringPorcentajeToNumber= (cadena) => {
    return stringDecimalComasToNumber(cadena);
}

export const stringMonedaToNumber= (cadena) => {
    return stringDecimalComasToNumber(cadena);
}

export const stringFechaHoraToNumber= (cadena) => {
    let dateTime= getDateTimeFromFormattedString(cadena);
    return dateTime.getTime();
}

export const stringFechaHora= (cadena) => {
    if (!cadena)
        return false;

    let parts = cadena.split(" ");
    if (parts.length !== 2)
        return false;

    let dateParts= parts[0].split("/");
    if (dateParts.length !== 3)
        return false;
    if (isNaN(dateParts[2]) || isNaN(dateParts[1]) || isNaN(dateParts[0]))
        return false;

    let timeParts= parts[1].split(":");
    if (timeParts.length !== 3)
        return false;
    if (isNaN(timeParts[0]) || isNaN(timeParts[1]) || isNaN(timeParts[2]))
        return false;


    let dateTime= new Date(dateParts[2], dateParts[1] - 1, dateParts[0], timeParts[0], timeParts[1], timeParts[2], 0);
    if (!dateTime)
        return false;

    return true;

}

export const truncarCadenaConEllip= (cadena, tamagno) => {
    if (!cadena)
        return "";
    if (cadena.length <= tamagno)
        return cadena;
    let cadenaTruncada = cadena.substr(0, tamagno-1);
    let posEspacio= cadenaTruncada.lastIndexOf(" ");
    if (posEspacio > 0)
        cadenaTruncada= cadenaTruncada.substr(0, posEspacio) + "..."; //+ "&hellip;";
    return cadenaTruncada;
}